import { blogCategories } from "../../data/blogContent";
import ArticleHighlights from "./ArticleHighlights";

const renderBlock = (block, index) => {
  switch (block.type) {
    case "h2":
      return (
        <h2 key={index} className="text-3xl font-semibold text-[#123070] mt-10 mb-4">
          {block.text}
        </h2>
      );
    case "ul":
      return (
        <ul key={index} className="list-disc list-inside space-y-3 text-gray-700 leading-relaxed">
          {block.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      );
    case "quote":
      return (
        <blockquote
          key={index}
          className="pl-6 border-l-4 border-blue-300 italic text-lg text-blue-900 leading-relaxed my-8"
        >
          {block.text}
        </blockquote>
      );
    case "p":
    default:
      return (
        <p key={index} className="text-gray-700 leading-loose text-lg">
          {block.text}
        </p>
      );
  }
};

const ArticleContent = ({
  article,
  categories = blogCategories,
  variant = "default",
  byAuthorLabel = "Por",
  keyTakeawaysTitle = "Puntos clave para recordar",
}) => {
  const category = categories[article.category];
  const isEmpresas = variant === "empresas";

  return (
    <section className="w-full bg-white">
      <div className="max-w-5xl mx-auto px-6 sm:px-10 lg:px-12 py-16">
        <div
          className={`flex flex-wrap items-center gap-4 text-sm font-medium ${
            isEmpresas ? "text-purple-700" : "text-blue-700"
          }`}
        >
          <span
            className={`px-3 py-1 rounded-full ${
              isEmpresas ? "bg-purple-50 text-purple-700" : "bg-blue-50 text-blue-700"
            }`}
          >
            {category?.title}
          </span>
          <span className="text-gray-400">{article.date}</span>
          <span className="text-gray-400">{article.readTime}</span>
          <span className="text-gray-500">
            {byAuthorLabel} {article.author}
          </span>
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold text-[#0f1a49] leading-tight mt-6">
          {article.title}
        </h1>
        <p className="mt-6 text-xl text-gray-600 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="mt-12 space-y-6">{article.content.map(renderBlock)}</div>
        {article.keyTakeaways?.length > 0 && (
          <ArticleHighlights
            highlights={article.keyTakeaways}
            variant={variant}
            title={keyTakeawaysTitle}
          />
        )}
      </div>
    </section>
  );
};

export default ArticleContent;
